import getApi from '@/lib/axios';
import { ResponsibleModel } from '../types';

export type ResponsibleDTO = ResponsibleModel;

type ResponsibleResponse = {
  id: number;
  nome: string;
  cpf: string;
  email: string
  telefone: string,
  endereco: string;
  onde_conheceu: string;
  escola_atual: string;
  turma: number;
  turno: number;
  serie: number;
};

async function createResponsible(responsible: ResponsibleDTO) {
  const api = await getApi();
  const payload = {
    nome: responsible.name,
    cpf: responsible.cpf,
    email: responsible.email,
    telefone: responsible.phone,
    endereco: responsible.address,
    onde_conheceu: responsible.where_did_you_meet,
    escola_atual: responsible.school,
    turma: responsible.turma_id,
    integracao: 1,
    aluno: {
      nome: responsible.student.nome,
      integracao: 1,
    },
    serie: responsible.serie_id,
    turno: responsible.turno_id,
  };

  const { data } = await api.post<ResponsibleResponse>('/crm/responsaveis/', payload);

  const item: ResponsibleModel = {
    id: data.id,
    name: data.nome,
    email: data.email,
    address: data.endereco,
    cpf: data.cpf,
    phone: data.telefone,
    where_did_you_meet: data.onde_conheceu,
    school: data.escola_atual,
    turma_id: data.turma,
    turno_id: data.turno,
    serie_id: data.serie,
  } as ResponsibleModel;

  return item;
}

export { createResponsible };
